<template>
    <Layout>
        <div class="row">
            <div class="col-md-12">
                <b-card v-if="users === 'has_no_permission'">
                    <PageHeader :title="title" :items="items" style="margin-top: -30px"/>
                    <div class="alert alert-danger alert-dismissible fade show" role="alert">
                        <h5>You are not permission to access this page</h5>
                    </div>
                </b-card>
                <b-card v-else>
                    <PageHeader :title="title" :items="items" style="margin-top: -30px"/>
                    <div class="row mb-2">
                        <div class="col-md-6">
                            <span class="badge badge-success mr-2">Total Search Data Found: {{ users.length }}</span>
                        </div>
                      <div class="col-md-6 float-right">
                        <b-button v-b-modal.user-modal type="button"
                                  @click="resetForm(),$bvModal.show('user-modal')"
                                  class="btn btn-success float-right btn-sm mb-1 text-black float-right">
                          Add User
                          <i class="fas fa-plus"></i>
                        </b-button>
                      </div>
                    </div>
                    <div class="table-responsive" style="overflow-x: auto">
                        <table class="table table-centered table-striped">
                            <thead>
                            <tr>
                                <th>Sl</th>
                                <th>Name</th>
                                <th>Designation</th>
                                <th>Org Name</th>
                                <th>Email</th>
                                <th>Active | Lock</th>
                                <th>Active | Lock Action</th>
                                <th>Role</th>
                                <th>Role Action</th>
                                <th>Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(user, index) in users" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ user.name }}</td>
                                <td>{{ user.designation }}</td>
                                <td>{{ user.org_name }}</td>
                                <td>{{ user.email }}</td>
                                <td>
                                    <span v-if="user.is_active === 1" class="badge badge-success">Active</span>
                                    <span v-else class="badge badge-danger">Inactive</span>
                                    |
                                    <span v-if="user.is_locked === 0" class="badge badge-success">Unlocked</span>
                                    <span v-else class="badge badge-danger">Locked</span>
                                </td>
                                <td>
                                    <span v-if="user.is_active === 1">
                                        <a href="javascript:void(0);" v-if="userPermission.includes('user-inactive')"
                                           class="action-icon" title="Deactivate User"
                                           @click.prevent="userDeactivate(user.id)">
                                            <i class="mdi mdi-thumb-up-outline addButton"></i>
                                        </a>
                                    </span>

                                    <span  v-else>
                                        <a href="javascript:void(0);" v-if="userPermission.includes('user-active')"
                                           class="action-icon" title="Activate User" @click.prevent="userActive(user.id)">
                                            <i class="mdi mdi-thumb-down-outline deleteButton"></i>
                                        </a>
                                    </span>
                                    |
                                    <span  v-if="user.is_locked === 1">
                                        <a href="javascript:void(0);" v-if="userPermission.includes('user-unlock')"
                                           class="action-icon" title="Unlocked User" @click.prevent="userUnlocked(user.id)">
                                        <i class="mdi mdi-block-helper deleteButton"></i>
                                    </a>
                                    </span>

                                    <span v-else>
                                        <a href="javascript:void(0);" v-if="userPermission.includes('user-lock')"
                                           class="action-icon" title="Locked User" @click.prevent="userLocked(user.id)">
                                            <i class="mdi mdi-block-helper addButton"></i>
                                        </a>
                                    </span>
                                </td>
                                <td>
                                    <span v-for="(role, index) in user.roles" v-bind:key="index"
                                      class="badge mr-1 badge-success">{{ role.name }}<br/>
                                    </span>
                                    <span v-if="user.roles.length === 0" class="badge badge-danger">No Role Assign</span>
                                </td>
                                <td>
                                    <span v-if="user.roles.length > 0">
                                        <a v-if="userPermission.includes('role-assign-create')" href="javascript:void(0);"  class="action-icon" title="Update Role"
                                           @click.prevent="getUserRoles(user),getRoles(),getUser(user.id), $bvModal.show('add-role')">
                                            <i class="mdi mdi-square-edit-outline editButton"></i>
                                        </a>
                                    </span>

                                    <span  v-else>
                                        <a v-if="userPermission.includes('role-assign-update')" href="javascript:void(0);" class="action-icon" title="Assign Role"
                                           @click.prevent="getRoles(),resetForm(),getUser(user.id), $bvModal.show('add-role')">
                                            <i class="mdi mdi-note-plus-outline addButton"></i>
                                        </a>
                                    </span>

                                    <span  v-if="userPermission.includes('role-assign-delete')">
                                        <a href="javascript:void(0);" v-if="user.roles.length > 0"
                                           class="action-icon" title="Delete Role" @click.prevent="onDeleteRole(user.id)">
                                            <i class="mdi mdi-delete deleteButton"></i>
                                        </a>
                                    </span>
                                </td>
                                <td>
                                  <b-button  variant="warning"
                                            class="btn btn-warning btn-xs waves-effect waves-light  mr-2"
                                            @click.prevent="getEditUser(user)">
                                    <i class="far fa-edit"></i></b-button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <h5 v-if="users.length === 0" class="text-center text-secondary">
                            No Data Found
                        </h5>
                    </div>
                </b-card>
            </div>
        </div>
        <add-role
                :user="user"
                :user_id="user_id"
                :roles="roles"
                :btn_edit="btn_edit"
                @getRoles="getRoles"
                @getUserRoles="getUserRoles"
                @resetForm="resetForm"
                @getUsers="getUsers"
        ></add-role>
      <user-modal
          :user="user"
          :btn_edit="btn_edit"
          @getUsers="getUsers"
          @resetForm="resetForm"
      ></user-modal>
    </Layout>
</template>

<script>
    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";

    import UserModal from "../modal/UserModal";
    import AddRole from "../../modals/AddRole";

    export default {
        page: {
            title: "Users List",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader, UserModal, AddRole},
        data() {
            return {
                title: "User List",
                items: [
                    {
                        text: "Dashboard",
                        href: "/"
                    },
                    {
                        text: "User List",
                        active: true
                    }
                ],
                users: [],
                roles: [],
                user_id: "",
                btn_edit: false,
                user: {},
            };
        },

        mounted() {
            this.getUsers();
            this.getRoles();
        },
        methods: {
            getUsers() {
                http.get("api/getUsers").then(response => {
                    if (!response.error) {
                        this.users = response.data.users;
                    }
                });
            },
            getEditUser(user) {
              this.user = {};
              this.btn_edit = true;
              http.get("api/users/" + user.id + "/edit").then(response => {
                if (!response.error) {
                  this.user = response.data.user;
                  this.$root.$emit("bv::show::modal", "user-modal");
                }
              });
            },
            getUser(id) {
                this.user_id = id;
            },
            getRoles() {
                http.get("api/getRoles").then(response => {
                    if (!response.error) {
                        this.roles = response.data.roles;
                    }
                });
            },
            resetForm() {
                this.btn_edit = false;
                this.user = {};
            },
            getUserRoles(user) {
                this.btn_edit = true;
                this.user = user;
            },
            onDeleteRole(id) {
                if (confirm("Do you really want to delete?")) {
                    http.delete("api/user/role/delete/" + id).then(response => {
                        if (response.data.permissionError) {
                            this.$bvToast.toast(response.data.permissionError, {
                                title: "Error",
                                autoHideDelay: 5000,
                                variant: "danger"
                            });
                        } else {
                            this.$bvToast.toast(response.data.message, {
                                title: "Success",
                                autoHideDelay: 5000,
                                variant: "success"
                            });
                            this.getUsers();
                        }
                    });
                }
            },
            userActive(id) {
                if (confirm("Do you really activate this user?")) {
                    http.post("api/user/active/" + id).then(response => {
                        if (response.data.permissionError) {
                            this.$bvToast.toast(response.data.permissionError, {
                                title: "Error",
                                autoHideDelay: 5000,
                                variant: "danger"
                            });
                        } else {
                            this.$bvToast.toast(response.data.message, {
                                title: "Success",
                                autoHideDelay: 5000,
                                variant: "success"
                            });
                            this.getUsers();
                        }
                    });
                }
            },
            userDeactivate(id) {
                if (confirm("Do you really want to deactivate this user?")) {
                    http.post("api/user/deactivate/" + id).then(response => {
                        if (response.data.permissionError) {
                            this.$bvToast.toast(response.data.permissionError, {
                                title: "Error",
                                autoHideDelay: 5000,
                                variant: "danger"
                            });
                        } else {
                            this.$bvToast.toast(response.data.message, {
                                title: "Success",
                                autoHideDelay: 5000,
                                variant: "success"
                            });
                            this.getUsers();
                        }
                    });
                }
            },
            userUnlocked(id) {
                if (confirm("Do you really unlocked this user?")) {
                    http.post("api/user/unlocked/" + id).then(response => {
                        if (response.data.permissionError) {
                            this.$bvToast.toast(response.data.permissionError, {
                                title: "Error",
                                autoHideDelay: 5000,
                                variant: "danger"
                            });
                        } else {
                            this.$bvToast.toast(response.data.message, {
                                title: "Success",
                                autoHideDelay: 5000,
                                variant: "success"
                            });
                            this.getUsers();
                        }
                    });
                }
            },
            userLocked(id) {
                if (confirm("Do you really want to locked this user?")) {
                    http.post("api/user/locked/" + id).then(response => {
                        if (response.data.permissionError) {
                            this.$bvToast.toast(response.data.permissionError, {
                                title: "Error",
                                autoHideDelay: 5000,
                                variant: "danger"
                            });
                        } else {
                            this.$bvToast.toast(response.data.message, {
                                title: "Success",
                                autoHideDelay: 5000,
                                variant: "success"
                            });
                            this.getUsers();
                        }
                    });
                }
            },
        },
        computed: {
              userPermission () {
                return this.$store.state.user
            }
        },
        created () {
            this.$store.dispatch('getUserPermission')
        },

    };
</script>
